import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import KeyIndicatorsNegociantsTable from '../KeyIndicatorsNegociantsTable';

const KeyIndicatorsNegociantsCardContainer = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
`;

export default class KeyIndicatorsNegociantsCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const formattedData = this.props.data;
    return (
      <KeyIndicatorsNegociantsCardContainer>
        <Card id="directVerticalGraph">
          <CardHeader
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.title'
            )}
            fontSize="20px"
          />
          <KeyIndicatorsNegociantsTable data={formattedData} />
        </Card>
      </KeyIndicatorsNegociantsCardContainer>
    );
  }
}
